function isElementInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function handleScroll() {
  const elements = document.querySelectorAll('.text-animate'); // Replace with your element's ID
  const elements2 = document.querySelectorAll('.text-animate-mobile'); // Replace with your element's ID
  if(elements.length > 0) {
    for(let i=0; i<elements.length; i++) {
      let element = elements[i];
      if (isElementInViewport(element) && !element.classList.contains("fadeInDown-animation")) {
        // Element is in viewport, perform your actions here
        element.classList.add('fadeInDown-animation');
      }
    }
  }
  if(elements2.length > 0) {
    for(let i=0; i<elements2.length; i++) {
      let element = elements2[i];
      if (isElementInViewport(element) && !element.classList.contains("fadeInDown-animation-mobile")) {
        // Element is in viewport, perform your actions here
        element.classList.add('fadeInDown-animation-mobile');
      }
    }
  }
}

// Attach the event listener to the window's scroll event
window.addEventListener('scroll', handleScroll);

var event1 = new Event("scroll");
window.dispatchEvent(event1);

function loadScript(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${src}`));
    document.head.append(script);
  });
}
if(typeof jQuery != "undefined") {
    handleScrollLink();
} else {
  loadScript("https://code.jquery.com/jquery-3.7.1.min.js")
  .then(() => {
    // Your jQuery code here
    handleScrollLink()
  })
  .catch((error) => {
    console.error("Error loading jQuery:", error);
  });
}
function handleScrollLink() {
  $(".scrollLink").click(function() {
    let elem = $(this).attr("href");
    if($(elem).length > 0) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(elem).offset().top - 20
      }, 1000);
    }
  });
}